import React from 'react';

import Async from './Async';
import Virtualized from './Virtualized';

/**
 * AsyncVirtualizedSelectBox, extends [SelectBox](selectbox) to add async and virtualized support
 */
const AsyncVirtualizedSelectBox = props => (
  <Async {...props}>{asyncProps => <Virtualized {...asyncProps} />}</Async>
);

export default AsyncVirtualizedSelectBox;
